export const HOME = 'HOME';
export const START = 'START';

export const LOGIN = 'LOGIN';
export const DOMAIN_REGISTER = 'DOMAIN_REGISTER';
export const REGISTER_CONFIRMATION = 'REGISTER_CONFIRMATION';
export const FORGOT_PASSWORD = 'FORGOT_PASSWORD';
export const RESET_PASSWORD = 'RESET_PASSWORD';
export const DELETE_ACCOUNT = 'DELETE_ACCOUNT';

export const ORDER = 'ORDER';
export const SUMMARY = 'SUMMARY';
export const CUSTOM_SUMMARY = 'CUSTOM_SUMMARY';
export const CONTACT_FORM = 'CONTACT_FORM';
export const THANK_YOU = 'THANK_YOU';

export const ACTIONS = 'ACTIONS';
export const ACTION = 'ACTION';
export const TEAMS = 'TEAMS';
